import { StateSchema } from 'app/config/storeConfig/types';

export const getPriceRaiseHistoryContractId = (state: StateSchema): Nullable<string> => state.priceRaiseHistoryModal.contractId;
